import React from 'react';
import PropTypes from 'prop-types';
import styled from "styled-components";
import HelpBlock from "./HelpBlock";

const Question = styled('div')`
  padding-bottom: 1em;
  
  & .title {
    font-weight: bold
  }
  
  & input {
    width: 100%;
  }         
  `;

const TextInput = ({title, value = '', onChange, disabled = false, error}) => (
  <Question>
    <div className="title">{title}</div>
    <input
      className="form-control"
      type="text"
      value={value}
      disabled={disabled}
      onChange={e => onChange(e.currentTarget.value)}
    />
    {error && (<HelpBlock text={error} type="error"/>)}
  </Question>
);

TextInput.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.string,
  error: PropTypes.bool,
  onChange: PropTypes.func.isRequired
};

export default TextInput;



// WEBPACK FOOTER //
// ./src/components/forms/TextInput.js